<template>
  <div>
    <div class="blue-subhead-bg text-uppercase">
      <h1>Rebates</h1>
    </div>

    <div class="container admin-approved-rebate">
      <br>
      <div v-if="!currentReceipt">
        <div class="np-left-push hidden-xs">
          <div class="row">
            <div class="col-sm-4"><strong>Name</strong></div>
            <div class="col-sm-3"><strong>Receipt Number</strong></div>
            <div class="col-sm-3"><strong>Date</strong></div>
          </div>
        </div>

        <div class="item-list">
          <div class="blue-outline-nh" v-for="(receipt, index) in approvedReceipts" :key="index">
            <div class="row">
              <div class="col-sm-4"><span class="visible-xs-inline-block"><strong>Name:</strong></span> {{ receipt.user.name || receipt.user.username }}</div>
              <div class="col-sm-3"><span class="visible-xs-inline-block"><strong>Receipt Number:</strong></span> {{ receipt.receiptNumber }}</div>
              <div class="col-sm-3"><span class="visible-xs-inline-block"><strong>Date:</strong></span> {{ formatDate(receipt.dateOfPurchase) }}</div>
              <div class="col-sm-2 text-right">
                <a
                  href=""
                  class="admin-clickable"
                  @click.prevent="currentReceipt = receipt"
                >
                  <strong>View</strong>
                </a>
              </div>
            </div>
          </div><!-- container-fluid -->
          <br>
          <router-link :to="{name: 'EditLoyaltyProgram'}" class="btn btn-lg admin-btn-primary col-md-2 col-md-offset-10">Back</router-link>
          <div class="clearfix"></div>
          <br>
        </div>
      </div>

      <div v-else>
        <div class="blue-outline-nh light-grey-type">
          <div class="row receipt-row-wrapper">
            <div class="col-sm-4 receipt-details-sec">
              <div class="receipt-details">
                <br>
                {{ user.name || 'N/A'}}<br>
                Invoice/Receipt #{{ currentReceipt.receiptNumber }}<br>
                Date of Purchase: {{ formatDate(currentReceipt.dateOfPurchase) }}<br>
                <ul>
                  <li
                    class="receipt-item"
                    v-for="(receiptItem, index) in currentReceipt.receiptItems" :key="index">
                    Item: {{ getRebateItem(receiptItem.item).name }}<br>
                    Points: {{ getRebateItem(receiptItem.item).points }}<br>
                    Quantity: {{ receiptItem.quantity }}<br>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-sm-8 receipt-image-sec">
              <br>
              <div class="pdf-container" v-if="receiptImageType === 'pdf'">
                <pdf :src="currentReceipt.image.url" class=""></pdf>
              </div>
              <img v-else-if="receiptImageType === 'image'" :src="currentReceipt.image.url" class="img-responsive center-block">
              <img v-else src="../../assets/images/proof-of-purchase.jpg" class="img-responsive center-block">
            </div>
          </div>
          <div class="col-sm-12">
            <a href=""
              class="admin-clickable"
              @click.prevent="currentReceipt = null">
                <strong>Back</strong>
            </a>
            <br>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <br><br>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import moment from 'moment'
import pdf from 'vue-pdf'

export default {
  name: 'ApprovedRebateSubmissions',
  components: {
    pdf
  },
  data () {
    return {
      currentReceiptItem: null,
      currentReceipt: null
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', [
      'programId',
      'approvedReceiptItems',
      'approvedReceipts'
    ]),
    ...mapState('loyaltyProgram', {
      program: state => state.program,
      receiptItems: state => state.receiptItems
    }),
    rebateItems () {
      return this.program.rebateItems
    },
    user () {
      return this.currentReceipt.user || {}
    },
    receiptImageType () {
      if (!this.currentReceipt) return
      if (this.currentReceipt.image.url !== null && this.currentReceipt.image.url.match(/\.pdf$/)) {
        return 'pdf'
      } else if (this.currentReceipt.image.url !== null) {
        return 'image'
      } else {
        return null
      }
    }
  },
  mounted () {
    this.getReceiptsByLoyaltyProgramId(this.programId)
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    ...mapActions('loyaltyProgram', [
      'getReceiptsByLoyaltyProgramId'
    ]),
    formatDate (date) {
      return moment(date).format('MM/DD/YYYY').toString()
    },
    getRebateItem (id) {
      return this.rebateItems.find(i => i._id === id)
    }
  }
}
</script>

<style scoped>
.receipt-row-wrapper {
  display: flex;
  max-height: 60vh;
}

.receipt-details-sec {
  max-height: 100%;
  display: flex;
  flex-direction: column;
}

.receipt-details {
  overflow-y: auto;
}

.receipt-image-sec {
  display: flex;
  flex-direction: column;
}

.pdf-container {
  flex: 1 1 350px;
  overflow-y: auto;
  border: 1px solid #e3e3e3;
}
</style>
